const formatDateToDutch = (date) => {
  if (!date) return "";

  const options = { day: "2-digit", month: "2-digit", year: "numeric" };
  return new Intl.DateTimeFormat("nl-NL", options).format(new Date(date));
};

export default formatDateToDutch;
